
// -------------------------------------------Google Map ------------------------------------------------------//
import React from "react";
import {
  GoogleMap,
  LoadScript,
  Marker,
  InfoWindow,
  Circle,
  LoadScriptNext,
} from "@react-google-maps/api";
import { CONSTANTS } from "config/constant";
import car from "../../assets/img//orders/orderDetail/car.png";
import AnimatedCircle from "./AnimatedCircle";

const mapContainerStyle = {
  height: "100%",
  width: "100%",
  
};
const iconSize = { width: 60, height: 60 }; // Adjust width and height as needed

const DriverMap = ({ drivers, onDriverSelect, radius, orderData }) => {
  const [selectedDriver, setSelectedDriver] = React.useState(null);
  const [mapCenter, setMapCenter] = React.useState({
    lat: orderData?.geo?.coordinates?.length
      ? orderData?.geo?.coordinates[0]
      : 0,
    lng: orderData?.geo?.coordinates?.length
      ? orderData?.geo?.coordinates[1]
      : 0,
  });

  const [googleMapsLoaded, setGoogleMapsLoaded] = React.useState(false);

  console.log("drivers inside map", mapCenter);

  // const center = {
  //   lat: drivers?.latitude,
  //   lng: drivers?.latitud,
  // };

  const handleMarkerClick = (driver) => {
    setSelectedDriver(driver);
    onDriverSelect(driver?.email);
  };
  const handleScriptLoad = () => {
    setGoogleMapsLoaded(true);
  };

  React.useEffect(() => {
    if (selectedDriver) {
      setMapCenter({
        lat: selectedDriver?.latitude,
        lng: selectedDriver?.longitude,
      });
    }
  }, [selectedDriver]);

  return (
    <LoadScriptNext
      googleMapsApiKey={CONSTANTS?.googleApikey}
      onLoad={handleScriptLoad}
      onError={() => console.error("Failed to load Google Maps API")}

      id="script-loader"
      loadingElement={<div>Loading...</div>}
      language="en"
      region="US"
      strategy="beforeInteractive"
    >
      {googleMapsLoaded && (
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={mapCenter}
          zoom={13}
          onUnmount={map => {
            // do your stuff before map is unmounted
          }}
        >
          {drivers?.map((driver) => (
            <Marker
              key={driver?.email}
              position={{ lat: driver?.latitude, lng: driver?.longitude }}
              onClick={() => handleMarkerClick(driver)}
              icon={{
                url: car,
                scaledSize: new window.google.maps.Size(
                  iconSize?.width,
                  iconSize?.height
                ), // Size of the marker
              }}
            />
          ))}

          {selectedDriver && (
            <>
              <InfoWindow
                position={{
                  lat: selectedDriver?.latitude,
                  lng: selectedDriver?.longitude,
                }}
                onCloseClick={() => setSelectedDriver(null)}
              >
                <div className="flex items-center rounded-lg border bg-white p-4 shadow-md">
                  <div className="flex-shrink-0">
                    <img
                      src={selectedDriver?.profile}
                      alt="Driver Profile"
                      className="h-16 w-16 rounded-full border-2 border-gray-300"
                    />
                  </div>
                  <div className="ml-4">
                    <h4 className="text-xl font-semibold text-gray-800">
                      {selectedDriver?.name}
                    </h4>
                    <p className="text-gray-600">{selectedDriver?.email}</p>
                    <p className="text-gray-600">{selectedDriver?.contact}</p>
                  </div>
                </div>
              </InfoWindow>
            </>
          )}
          <AnimatedCircle orderData={orderData} radius={radius} />
        </GoogleMap>
      )}
    </LoadScriptNext>
  );
};

export default DriverMap;
